import styled from 'styled-components'
import MttGrid from 'components/Material/MttGrid/MttGrid'

export const Container = styled(MttGrid)<{ metaBlock?: boolean }>`
  margin: ${(props) => (props.metaBlock ? 0 : '16px')};
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
`
